module.exports = __webpack_public_path__ + "static/media/icon-close.87727f93.svg";